/**
 * async ready setTimeout
 * @param {number|undefined} ms
 * @return {Promise<void>}
 */
export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
export default sleep;